<template>
  <div class="home-container">
    <div class="home-content" v-if="recordFlag">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="img" label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img[0]" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>
        <el-table-column prop="praiseCount" label="点赞" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="查看评论" align="center">
          <template slot-scope="scope">
            <a @click="bindRecord(scope.row.id)">查看评论</a>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片" prop="img">
                <multigraph     
                  :url.sync="addData.img"
                  :src="addData.img"
                  :many="3"
                  ></multigraph>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-row> 
            <el-col :span="12">
              <el-form-item label="选择分类" prop="communityServiceCategoryId">
                <el-select
                  clearable filterable
                  v-model="addData.communityServiceCategoryId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in classList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否启用" prop="status">
                <el-select clearable filterable v-model="addData.status" placeholder="请选择">
                  <el-option label="启用" :value="1"> </el-option>
                  <el-option label="禁用" :value="-1"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动内容" prop="content">
                <ueditor v-model="addData.content"></ueditor>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div v-else>
      <commentList :activityId="activityId" @back="back"></commentList>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor";
import commentList from "./components/commentList.vue";
import multigraph from "../../components/multigraph"
export default {
  components: {
    upload,
    ueditor,
    commentList,
    multigraph
  },
  data() {
    return {
      searchForm: {
        room: "",
        userName: "",
        phone: "",
      },
      houseFlag: true,
      modalTitle: "新增",
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      classList: [],
      addData: {
        id: "",
        img: "",
        content: "",
        status: "",
        communityServiceCategoryId: "",
        title:''
      },
      addDataRules: {
        img: [{ required: true, message: "请上传图片", trigger: "blur" }],
        // title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        communityServiceCategoryId: [
          { required: true, message: "请选择分类", trigger: "blur" },
        ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      activityId: "",
      recordFlag: true,
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    back() {
      this.recordFlag = true;
    },
    // 活动记录
    bindRecord(row) {
      this.activityId = row;
      this.recordFlag = false;
    },
    // 修改状态
    updataStatus(row) {
      let data = {
        id: row.id,
        status: row.status ? 1 : -1,
      };
      this.$Apis.bannerStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.img = []
      this.addData.status = 1
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.neighboursDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {

      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let img = this.addData.img.map(res=> res.url ? res.url : res).join(',')
          var data = {
            id: this.addData.id || "",
            img: img,
            content: this.addData.content,
            title:this.addData.title,
            status: this.addData.status,
            communityServiceCategoryId:this.addData.communityServiceCategoryId,
            type: 2,
          };
          this.$Apis.neighboursAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
      this.isShowloading = true;
      this.$Apis.communityClassAllList().then((res) => {
        this.classList = res.data;
      });
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        verifyStatus:1
      };
      this.$Apis.neighboursList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.ind = ind + 1;
            item.img = item.img.split(',')
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>